import React from "react";
const injectGA = () => {
  if (typeof window == "undefined") {
    return;
  }
  const script = document.createElement("script");
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-8EGXD0ZV5Z";
  script.async = true;
  document.body.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", "G-8EGXD0ZV5Z");
};
export function GoogleAnalytics() {
  return <>{process.env.NODE_ENV !== "development" ? injectGA() : ""}</>;
}
